import React from "react";
import "../styles/about.css";
import "../styles/master.css";
import aboutData from "../data/aboutusData.json";

const About = () => {
  return (
    <section id="about" className="section">
      <h2 className="title">{aboutData.title}</h2>
      <p className="main-content">{aboutData.mainContent}</p>

      <div className="about-sections">
        {aboutData.sections.map((section, index) => (
          <div key={index} className="about-section">
            <h3>{section.title}</h3>
            <p>{section.content}</p>
          </div>
        ))}
      </div>

      <p className="main-content">{aboutData.mainContent1}</p>
      <p className="main-content">{aboutData.mainContent2}</p>
      <p className="main-content">{aboutData.mainContent3}</p>
    </section>
  );
};

export default About;
